if (typeof QuickView === "undefined") {
  const { FoxThemeStyles, FoxThemeScripts } = window;
  const MOBILE_QUERY = "screen and (max-width: 767px)";
  class QuickView {
    constructor() {
      this.modal = null;
      this.stickyBar = null;

      addEventDelegate({
        selector: "[data-product-quickview]",
        handler: (e, target) => {
          e.preventDefault();
          const productHandle = target.dataset.productQuickview;
          if (!productHandle) return;

          const isMobile = window.matchMedia(MOBILE_QUERY).matches;
          if (isMobile && window.FoxThemeSettings.template === "product") return;

          this.target = target;
          target.classList.add("btn--loading");
          if (isMobile) {
            this.fetchStickyBar(productHandle);
          } else {
            this.fetchHtml(productHandle);
          }
        },
      });

      addEventDelegate({
        selector: "[data-quickview-bar-close]",
        handler: (e) => {
          e.preventDefault();
          this.hideStickyBar();
        },
      });

      document.addEventListener("unmatchMobile", () => this.removeStickyBar());

      window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        if (this.modal) this.modal.hide();
      });

      window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.variantChange, (evt) => {
        const productInfo = this.modal?.querySelector("product-info");
        if (!productInfo) return;
        if (evt.data.sectionId !== productInfo.dataset.section) return;
        setTimeout(() => window.reInitializeCS?.(true), 100);
      });
    }

    fetchStickyBar(productHandle) {
      const target = this.target;
      loadAssets([FoxThemeStyles.stickyAtcBar], "sticky-atc-bar-css");
      fetchSection("product-quickview-atc-bar", {
        url: `${window.FoxThemeSettings.base_url}products/${productHandle}`,
      })
        .then((html) => {
          const bar = html.querySelector(".sticky-atc-bar");
          if (!bar) return;

          this.removeStickyBar();
          this.stickyBar = bar;
          document.body.appendChild(bar);
          document.body.classList.add("quickview-atc-bar-enabled");

          document.documentElement.style.setProperty(
            "--f-quickview-atc-bar-height",
            `${bar.offsetHeight}px`
          );
          bar.classList.add("sticky-atc-bar--show");

          window.rerunCsLinks();
          window.reInitializeCS();

          document.dispatchEvent(
            new CustomEvent("quick-view:bar-open", {
              detail: { productUrl: `/products/${productHandle}` },
            })
          );
        })
        .catch(console.error)
        .finally(() => target.classList.remove("btn--loading"));
    }

    hideStickyBar() {
      const bar = this.stickyBar;
      if (!bar) return;

      bar.classList.remove("sticky-atc-bar--show");
      setTimeout(() => {
        if (this.stickyBar === bar) this.removeStickyBar();
      }, 300);
    }

    removeStickyBar() {
      if (this.stickyBar) {
        this.stickyBar.remove();
        this.stickyBar = null;
      }
      document.body.classList.remove("quickview-atc-bar-enabled");
      document.documentElement.style.removeProperty(
        "--f-quickview-atc-bar-height"
      );
    }

    fetchHtml(productHandle) {
      loadAssets(
        [FoxThemeStyles.product, FoxThemeStyles.volumePricing],
        "quick-view-assets"
      );
      fetchSection("product-quickview", {
        url: `${window.FoxThemeSettings.base_url}products/${productHandle}`,
      })
        .then((html) => {
          this.modal = html.querySelector("modal-dialog");
          const firstModel = html.querySelector("product-model");
          this.mediaGallery = this.modal.querySelector("media-gallery");
          document.body.appendChild(this.modal);
          loadAssets(
            [
              FoxThemeScripts.productInfo,
              FoxThemeScripts.productMedia,
              FoxThemeScripts.variantsPicker,
              FoxThemeScripts.volumePricing,
            ],
            "variants-picker",
            () => {
              this.modal && this.modal.show(this.target);
              document.dispatchEvent(
                new CustomEvent("quick-view:open", {
                  detail: { productUrl: `/products/${productHandle}` },
                })
              );
              if (this.mediaGallery) {
                const thumb = this.mediaGallery.querySelector(
                  '[id^="GalleryThumbnails"]'
                );
                if (thumb) thumb.update();
                this.mediaGallery.update();
              }
              if (Shopify && Shopify.PaymentButton) {
                Shopify.PaymentButton.init();
              }
              this.target.classList.remove("btn--loading");
              this.handleClose();
              this.toolTip = __reInitTooltip(this.modal);

              document.dispatchEvent(
                new CustomEvent("quick-view:loaded", {
                  detail: { productUrl: `/products/${productHandle}` },
                })
              );
            }
          );
          if (firstModel) {
            loadAssets(
              [
                FoxThemeScripts.productModel,
                "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css",
              ],
              "product-model-assets"
            );
          }
          // add WTB button
          window.rerunCsLinks();
          window.reInitializeCS();
        })
        .catch(console.error);
    }

    handleClose() {
      if (!this.modal) return;
      this.modal.addEventListener("close", () => {
        const allTooltip = [
          ...(this.modal.querySelector("product-info")?.toolTip || []),
          ...(this.toolTip || []),
        ];
        allTooltip.forEach((item) => item.unmount());

        const quantityInputs = this.modal.querySelectorAll("quantity-input");
        quantityInputs.forEach((input) => {
          input.disconnectedCallback();
        });

        this.modal.remove();
      });
    }
  }
  new QuickView();
  window.QuickView = QuickView;
}
